import React from 'react';
import { Icon } from '../Icon/Icon.jsx';
import { BODY } from '../../primitives.js';

const h = React.createElement;

/**
 * The text field. Density-aware height. Plus any native input attribute.
 *
 * @param {object} p
 * @param {'sm'|'md'} [p.size]
 * @param {boolean} [p.invalid]
 * @param {boolean} [p.warning]
 * @param {boolean} [p.readOnly]
 * @param {boolean} [p.disabled]
 * @param {string} [p.icon]
 * @param {any} [p.inputRef]
 * @param {React.CSSProperties} [p.style]
 * @param {any} [p.attr] - plus any native attribute
 */
export function Input({ size = 'md', invalid, warning, readOnly, disabled, icon, style, inputRef, ...rest }) {
  const H = size === 'sm' ? 'var(--ctl-h-sm)' : 'var(--ctl-h)';
  const field = h('input', { ref: inputRef, readOnly, disabled, 'aria-invalid': invalid || undefined, ...rest, className: 'gx-input',
    style: { width: '100%', height: H, boxSizing: 'border-box', padding: icon ? '0 12px 0 34px' : '0 12px', fontFamily: rest.type === 'number' ? BODY : BODY, fontSize: size === 'sm' ? 12.5 : 13.5, fontWeight: 600, color: readOnly ? 'var(--tx2)' : 'var(--tx)',
      background: readOnly ? 'var(--inset)' : 'var(--input)', border: readOnly ? '2px dashed var(--line2)' : `2px solid ${invalid ? 'var(--coral)' : warning ? 'var(--gold-tx)' : 'var(--ink)'}`, borderRadius: size === 'sm' ? 8 : 10, outline: 'none', opacity: disabled ? .55 : 1, cursor: disabled ? 'not-allowed' : undefined, ...style } });
  if (!icon) return field;
  return h('span', { style: { position: 'relative', display: 'block' } }, h('span', { style: { position: 'absolute', left: 11, top: '50%', transform: 'translateY(-50%)', color: 'var(--mut)', display: 'flex', pointerEvents: 'none' } }, h(Icon, { name: icon, size: 15 })), field);
}
